import React, {useEffect, useState} from "react";
import { Button, Card, Grid, Stack, Typography } from "@mui/joy";
import IProfile from "../../types/profile.type";
import {Experimental_CssVarsProvider as CssVarsProvider} from "@mui/material/styles/ThemeProviderWithVars";
import {TextField} from "@mui/material";
import {GridSaveAltIcon} from "@mui/x-data-grid";
import {useFormik} from "formik";
import * as Yup from "yup";
import {updateAddress} from "../../services/profile.service";
import showNotification from "../utils/Notify";
import IAddress from "../../types/address.type";
import HomeIcon from "@mui/icons-material/Home";
import CancelIcon from "@mui/icons-material/Cancel";
import BorderColorIcon from "@mui/icons-material/BorderColor";

interface Props {
  userId: any,
  profile: IProfile | undefined,
}

const AddressDataForm: React.FC<Props> = (props) => {
  const { profile } = props;
  const [edit, setEdit] = useState(false);

  const initialValues: IAddress = {
    address: "",
    city: "",
    postalCode: "",
    province: ""
  };

  const validationSchema = Yup.object({
    address: Yup.string().required('El Domicilio es requerido'),
    city: Yup.string().required('La Ciudad es requerido'),
    postalCode: Yup.string().required('El Codigo Postal es requerido'),
    province: Yup.string().required('La Provincia es requerido'),
  });

  const onSubmit = (address: IAddress) => {
    if (profile?.id) {
      updateAddress(profile?.id, address)
        .then((response) => {
          showNotification({type: 'success', message: 'Se actualizo la Direccion.'});
          profile.address = response.data;
          setEdit(false);
        })
        .catch(error => {
          showNotification({type: 'error', message: error.response.data.message});
        });
    }
  };

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: initialValues,
    onSubmit,
    validationSchema: validationSchema,
  });

  const handleEditCancelClick = () => {
    formik.setTouched({});
    if (edit) {
      setEdit(false);
      if (profile?.address) {
        formik.setValues(profile.address);
      } else {
        formik.resetForm();
      }
    } else {
      setEdit(true);
    }
  };

  useEffect(() => {
    if (profile?.address) {
      formik.setValues(profile.address);
    }
  }, [profile?.id]);

  return (
    <Card sx={{gap: 0, marginTop: 2}}>
      <Typography level="h4" startDecorator={<HomeIcon/>}>Dirrecion</Typography>
      <form className="form" onSubmit={formik.handleSubmit}>
        <Grid container rowSpacing={2} columnSpacing={2} marginBlock={1}>
          <Grid xl={6} md={6} sm={6} xs={6}>
            <CssVarsProvider>
              <TextField
                fullWidth
                id="address"
                label="Domicilio"
                name="address"
                variant="filled"
                type={"text"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.address}
                error={!!(formik.touched.address && formik.errors.address) && edit}
                slotProps={{inputLabel: {shrink: true}, input: {readOnly: !edit}}}
              />
              {(formik.touched.address && formik.errors.address) && edit ? (
                <span className="Error-alert">{formik.errors.address}</span>
              ) : null}
            </CssVarsProvider>
          </Grid>
          <Grid xl={6} md={6} sm={6} xs={6}>
            <CssVarsProvider>
              <TextField
                fullWidth
                id="city"
                label="Localidad"
                name="city"
                variant="filled"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.city}
                error={!!(formik.touched.city && formik.errors.city) && edit}
                slotProps={{inputLabel: {shrink: true}, input: {readOnly: !edit}}}
              />
              {(formik.touched.city && formik.errors.city) && edit ? (
                <span className="Error-alert">{formik.errors.city}</span>
              ) : null}
            </CssVarsProvider>
          </Grid>
          <Grid xl={6} md={6} sm={6} xs={6}>
            <CssVarsProvider>
              <TextField
                fullWidth
                id="postalCode"
                label="Codigo Postal"
                name="postalCode"
                variant="filled"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.postalCode}
                error={!!(formik.touched.postalCode && formik.errors.postalCode) && edit}
                slotProps={{inputLabel: {shrink: true}, input: {readOnly: !edit}}}
              />
              {(formik.touched.postalCode && formik.errors.postalCode) && edit ? (
                <span className="Error-alert">{formik.errors.postalCode}</span>
              ) : null}
            </CssVarsProvider>
          </Grid>
          <Grid xl={6} md={6} sm={6} xs={6}>
            <CssVarsProvider>
              <TextField
                fullWidth
                id="province"
                label="Provincia"
                name="province"
                variant="filled"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.province}
                error={!!(formik.touched.province && formik.errors.province) && edit}
                slotProps={{inputLabel: {shrink: true}, input: {readOnly: !edit}}}
              />
              {(formik.touched.province && formik.errors.province) && edit ? (
                <span className="Error-alert">{formik.errors.province}</span>
              ) : null}
            </CssVarsProvider>
          </Grid>
        </Grid>
        <Stack direction="row" justifyContent="flex-end" spacing={2} pt={1}>
          <Button variant="outlined" endDecorator={edit ? <CancelIcon/> : <BorderColorIcon />} onClick={handleEditCancelClick}>{edit ? 'Cancelar' : 'Editar'}</Button>
          <Button type="submit" variant="solid" endDecorator={<GridSaveAltIcon/>} disabled={!edit}>Guardar</Button>
        </Stack>
      </form>
    </Card>
  );
};

export default AddressDataForm;
